// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"indexLayout-module--fullscreen--39oyr"};